// extracted by mini-css-extract-plugin
export default {"default":"style_default__MfR5R","overlay":"style_overlay__uhuFh","fit":"style_fit__7M1Jc"};